import { FullScreenPopup } from 'common-front/src/components/fullScreenPopup/fullScreenPopup';
import { Button } from 'common-front/src/designSystem/components/button';
import { Select } from 'common-front/src/designSystem/form/select/select';
import { TextInput } from 'common-front/src/designSystem/form/textInput';
import { useEnumToOptions } from 'common-front/src/hooks/useEnumToOptions';
import { useHeavent } from 'common-front/src/hooks/useHeavent';
import { Box } from 'common/src/designSystem/components/box';
import { Flex } from 'common/src/designSystem/components/flex';
import { ALL_WORKFLOWSTATE, WorkflowInput } from 'common/src/generated/types';
import { WorkflowsPaths } from 'common/src/util/paths/workflowsPaths';
import * as React from 'react';
import { NotSavedModal } from '../../../documentBuilder/notSavedModal';
import { UpdateWorkflowSteps } from '../updateWorkflowSteps';

interface IUpdateWorkflowFormProps {
    category: string;
    hasBeenExecuted: boolean;
    initialValuesString: string;
    isEdit: boolean;
    name: string;
    submitting: boolean;
    workflow: WorkflowInput;

    change(name: string, value: any): void;
    handleSubmit(): void;
}

export const UpdateWorkflowForm = React.forwardRef(
    (props: IUpdateWorkflowFormProps, ref: React.Ref<HTMLDivElement>) => {
        const {
            history,
            translate,
            params: { organizationId, eventId }
        } = useHeavent();
        const enumToOptions = useEnumToOptions();
        const [isNotSavedModalOpen, setIsNotSavedModalOpen] = React.useState(false);
        const onClose = React.useCallback(() => {
            const workflowString = JSON.stringify(props.workflow);

            if (workflowString === props.initialValuesString) {
                history.goBack(WorkflowsPaths.WORKFLOWS({ organizationId, eventId }));
            } else {
                setIsNotSavedModalOpen(true);
            }
        }, [props.workflow, props.initialValuesString, setIsNotSavedModalOpen]);

        return (
            <>
                <FullScreenPopup
                    button={
                        <Button isLoading={props.submitting} onClick={props.handleSubmit}>
                            {props.isEdit
                                ? translate('mettre_jour_l_18144')
                                : translate('cr_er_l_automat_04638')}
                        </Button>
                    }
                    category={props.category}
                    color="dark"
                    title={props.isEdit ? props.name : translate('nouvelle_automa_77863')}
                    onClose={onClose}
                >
                    <Flex height={1}>
                        <Flex
                            css={{
                                background: 'white',
                                padding: '$6'
                            }}
                            direction="column"
                            gap="7"
                            width={420}
                        >
                            <Box font="gray800 textMd medium">
                                {translate('param_tres_de_l_25166')}
                            </Box>

                            <Flex direction="column" gap="4">
                                <TextInput
                                    label={translate('nom_de_l_automa_04883')}
                                    name="workflow.name"
                                />

                                <Select label={translate('status_06428')} name="workflow.state">
                                    {enumToOptions(ALL_WORKFLOWSTATE)}
                                </Select>
                            </Flex>
                        </Flex>

                        <Flex
                            ref={ref}
                            css={{
                                background: '$gray50',
                                flex: '1',
                                overflowY: 'auto',
                                padding: '$8'
                            }}
                            direction="column"
                            height={1}
                        >
                            <UpdateWorkflowSteps
                                change={props.change}
                                hasBeenExecuted={props.hasBeenExecuted}
                                isEdit={props.isEdit}
                                workflow={props.workflow}
                            />
                        </Flex>
                    </Flex>
                </FullScreenPopup>

                <NotSavedModal
                    fallbackPath={WorkflowsPaths.WORKFLOWS({ organizationId, eventId })}
                    isOpen={isNotSavedModalOpen}
                    onClose={() => setIsNotSavedModalOpen(false)}
                />
            </>
        );
    }
);
UpdateWorkflowForm.displayName = 'UpdateWorkflowForm';
